// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__377v0","right":"Footer_right__1uoX0","buttons":"Footer_buttons__DFPbZ"};